'use client'

type GTMPayload = Record<string, unknown>

declare global {
  interface Window {
    dataLayer?: GTMPayload[]
  }
}

/**
 * GTM tracking helper.
 *
 * Event reference:
 * - cta_click: Miembro interactúa con cualquier botón/Link principal; payload incluye `place`, `cta`, `href`.
 * - product_tab_view: Usuario selecciona una pestaña de capacidades en la página de producto; payload incluye `tab`.
 * - scroll_depth: Usuario alcanza umbrales de scroll (por ejemplo, 50%); payload incluye `depth`.
 */
export function track(event: string, payload: GTMPayload = {}) {
  if (typeof window === 'undefined') {
    return
  }

  window.dataLayer = window.dataLayer ?? []

  window.dataLayer.push({
    event,
    ...payload,
  })
}
